import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getInventoryGeneral, getInventoryMain, saveCataloge } from '../../actions/inventoryActions'
import InventoryListView from '../../containers/Inventory/InventoryGeneral/InventoryListView'
import localStorage from '../../utils/hooks/useLocalStorage'

const InventoryList = () => {
  const { products } = useSelector(state => state.inventory)
  const { userInfo } = useSelector(state => state.userInfo)
  const [cataloge, setCataloge] = useState(null)
  const dispatch = useDispatch()
  useEffect(() => {
    let type = "";
    let id = "";
    if (userInfo.representativeID) {
      if (userInfo.representativeID.state ===2) {
        type = "general"
        id = userInfo.representativeID._id
      }
    }
    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state ===2) {
        type = "general"
        id = userInfo.franchiseID._id
      }
    }
    if (userInfo.warehouseID) {
      type = "main"
      id = userInfo.warehouseID

    }
    if (type ==="general") {
      dispatch(getInventoryGeneral(id))
    }
    if (type ==="main") {
      dispatch(getInventoryMain(id))
    }


    return () => {

    }
  }, [userInfo])
  const loadCataloge = () => {
    const formData = new FormData()
    formData.append('files',cataloge)
    formData.append('userId',localStorage().getItem('idProfile'))
    dispatch(saveCataloge(formData))

  }
  return (
    <InventoryListView products={products} cataloge={cataloge} setCataloge={setCataloge} loadCataloge={loadCataloge} />
  )
}

export default InventoryList